<template>
  <iframe allowfullscreen class="report" frameborder="0" :src="config.embedUrl" style="border: 0"></iframe>
</template>

<script>
export default {
  name: 'LookerBIReport',
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.report {
  width: 100%;
  height: 100%;
}
</style>
